import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { StatusCodes } from 'http-status-codes';
import { useHistory, useParams } from 'react-router-dom';
import { GenericProductGetDTO } from 'svila-common';

import InventoryApi from '../../../../services/api/InventoryApi';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import GenericProductsApi from '../../../../services/api/GenericProductsApi';
import InventoryAddEditForm from '../components/InventoryAddEditForm';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import { fullSchema } from '../InventorySchema';
import { InventoryFormikValuesDto } from '../../../../types/InventoryFormikValuesDto';
import { createEmptyInventoryFormik } from '../../../../types/convertors/createEmptyInventoryFormik';
import { formikToTransactionAddDto } from '../../../../types/convertors/formikToTransactionAddDto';

interface ParamTypes {
  genericId: string;
}

export default function InventoryAdd(): JSX.Element {
  const { genericId } = useParams<ParamTypes>();
  const history = useHistory();

  const [generic, setGeneric] = useState<GenericProductGetDTO | null>(null);

  const getGenericItem = async (): Promise<void> => {
    const result = await GenericProductsApi.get(genericId);
    setGeneric(result.data);
  };

  const saveItem = async (
    values: InventoryFormikValuesDto,
    setSubmitting: (isSubmitting: boolean) => void,
  ): Promise<void> => {
    setSubmitting(true);
    const dto = formikToTransactionAddDto(values, genericId);
    const result = await InventoryApi.add(dto);
    if (result.status === StatusCodes.OK) {
      history.push(`/inventory/list-for-generic/in-warehouse/${dto.warehouseId}/${genericId}`);
    }
    setSubmitting(false);
  };

  const initialValues = createEmptyInventoryFormik();
  const formik = useFormik({
    initialValues,
    validationSchema: fullSchema,
    onSubmit: async (values, { setSubmitting }) => {
      return saveItem(values, setSubmitting);
    },
  });

  useEffect(() => {
    if (genericId) {
      getGenericItem();
    }
  }, []);

  return (
    <WhitePad isFluid>
      <TitleComponent
        onLeftHandler={(): void => {
          history.push(`/inventory/select-product`);
        }}
        title="Create Warehouse Stock"
      />
      {generic && <InventoryAddEditForm formikProps={formik} generic={generic} />}
    </WhitePad>
  );
}
